/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {

    async function configureCustomCheckout(cart) {
      console.log("configureCustomCheckout", cart);
  
      // id = CartDrawer-Checkout
      const customCheckout = $('button[id="CartDrawer-Checkout"]');
      console.log("customCheckout", customCheckout);

      customCheckout.unbind("click").bind("click", async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const params = new URLSearchParams();

        const currentSite = localStorage.getItem("CURRENT_SITE");
        if (currentSite) {
            console.log("currentSit added: ", currentSite);
            params.append("attributes[sponsorWebAlias]", currentSite);
        }
        
        let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
        if (!sessionId) {
          sessionId = Date.now();
          sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
        }

        const context = {
            curSite: localStorage.getItem("CURRENT_SITE") ?? null,
            customerId: window?.customer?.id,
            customerEmail: window?.customer?.email,
            isPartner: window?.customer?.isPartner,
        };

        console.log("customCheckout clicked", context);
        params.append("attributes[sessionID]", sessionId);
        params.append("attributes[context]", btoa(JSON.stringify(context)));

        const checkoutURL = `/checkout?${params.toString()}`;
        console.log("Redirecting to checkout:", checkoutURL);

        setTimeout(() => {
          window.location.href = checkoutURL;
        }, 500);
      });
    }
  
  
    async function initConfigureCustomCheckout() {
      const cart = await fetch("/cart.js")
        .then((res) => res.json())
        .catch((e) => console.log(e));
      configureCustomCheckout(cart);
    }
  
    // Make function globally accessible
    window.initConfigureCustomCheckout = initConfigureCustomCheckout;
  
    document.addEventListener("DOMContentLoaded", initConfigureCustomCheckout);
  
    async function getPartyWebAlias(partyId) {
      try {
        const response = await fetch(
          `https://ff-prd.api.sultans.co/dashboard/parties/${partyId}`,
          {
            method: "GET",
            headers: this.headers,
          }
        );
  
        if (!response.ok) {
          throw new Error("Failed to fetch party info");
        }
  
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error fetching party webAlias:", error);
        return null;
      }
    }
  
    document.addEventListener("DOMContentLoaded", async () => {
      console.log("DOMContentLoaded party");
      const urlParams = new URLSearchParams(window.location.search);
      const partyId = urlParams.get("party");
      console.log("urlParams:", urlParams);
  
      if (partyId) {
        console.log("partyId:", partyId);
        const response = await getPartyWebAlias(partyId);
        console.log("response:", response);
  
        if (response && response.webAlias) {
          console.log("webAlias:", response.webAlias);
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set("pws", response.webAlias);
          window.history.replaceState({}, "", newUrl);
        }
      }
    });
  })();
  